module.exports = __webpack_public_path__ + "img/004王建民.71ec5552.png";